import React from "react";
import EAElevatedContainer from "../shared/EAElevatedContainer";
import EADivider from "../shared/EADivider";
import EAButton from "../shared/Buttons/EAButton";
import { FaArrowRight } from "react-icons/fa";

interface IProps {
  title: string;
  description: string;
  children: any;
  showButtons: boolean;
  showGoBackButton?: boolean;
  onClickGoBack: () => void;
  onClickNext: () => void;
  disabledAccept?: boolean;
  acceptText?: string;
  previousStepInfo?: string;
}

const GdanskSaleContentContainer: React.FC<IProps> = ({
  title,
  description,
  children,
  showButtons,
  showGoBackButton = true,
  onClickGoBack,
  onClickNext,
  disabledAccept = false,
  acceptText = "Przejdź dalej",
  previousStepInfo = "",
}) => {
  return (
    <>
      {previousStepInfo && (
        <div className="gdansk-sale-content-container__previous-step-info">
          <h5>
            Wybrano: <span className="text-color-main">{previousStepInfo}</span>
          </h5>
        </div>
      )}

      <EAElevatedContainer>
        <div className="gdansk-content-container">
          <div className="gdansk-content-container-header">
            <h2 className="no-line-height">{title}</h2>
            <p>{description}</p>
          </div>

          {children}

          {showButtons && (
            <>
              <EADivider />
              <div className="gdansk-content-container-buttons">
                {showGoBackButton && <EAButton title="Powrót" variant="text" onClick={onClickGoBack} />}
                <EAButton
                  title={acceptText}
                  endIcon={<FaArrowRight />}
                  onClick={onClickNext}
                  disabled={disabledAccept}
                />
              </div>
            </>
          )}
        </div>
      </EAElevatedContainer>
    </>
  );
};

export default GdanskSaleContentContainer;
